var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"projectcount",staticClass:"pbr-index-chart"},[_c('Empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }